















import {computed, defineComponent} from "@vue/composition-api";

export default defineComponent({
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    setup(props, {emit}) {

        const localShow = computed<boolean>({
            get() {
                return props.show;
            },
            set(newValue: boolean) {
                emit('update:show', newValue);
            }
        });

        return {localShow}
    }
});

